
import Vue from 'vue'
import { mapStores } from 'pinia'
import { useWebsocketsStore } from '../stores/websockets-screen-client'
import { fetch } from '@tauri-apps/api/http'

enum SednaCommand {
  Start = 'start',
  Stop = 'stop'
}

enum SednaAssetType {
  Playlist = 'playlist',
  Arrangement = 'arrangement',
  TimedPlaylist = 'timed-playlist'
}

class SednaTriggerOptions {
  host!: string

  type!: SednaAssetType
  command!: SednaCommand

  name!: string
  overlay!: boolean
  loop!: boolean

  fadeIn?: number
  fadeOut?: number
}

const commands = ['SEDNA_EXECUTE', 'CLEAR_QUEUE']

export default Vue.extend({
  name: 'CommandBouncer',
  computed: {
    ...mapStores(useWebsocketsStore),
    sednaUrl () {
      return this.sednaTarget + '/services;execute?command='
    }
  },
  data () {
    return {
      connected: false,
      errors: [] as string[],
      messages: [] as string[],

      reflectWSSTarget: 'wss://mnf6kgc614.execute-api.eu-west-1.amazonaws.com/development_private',
      reflectProjectId: '',
      reflectScreenId: '',
      reflectPasskey: '',
      sednaTarget: 'http://localhost:8080',

      timeouts: [],

      isAutoConnect: false
    }
  },
  mounted () {
    this.loadSettings()

    this.isAutoConnect = localStorage.getItem('autoconnect') === 'true'

    if (this.isAutoConnect) {
      this.connect()
    }
  },
  methods: {
    toggleAutoConnect () {
      const isTrue = localStorage.getItem('autoconnect') === 'true'

      localStorage.setItem('autoconnect', String(!isTrue))

      this.isAutoConnect = !isTrue
    },
    loadSettings () {
      try {
        const settings = JSON.parse(localStorage.getItem('settings') || '')

        this.reflectWSSTarget = settings.reflectWSSTarget
        this.reflectProjectId = settings.reflectProjectId
        this.reflectScreenId = settings.reflectScreenId
        this.reflectPasskey = settings.reflectPasskey
        this.sednaTarget = settings.sednaTarget
      } catch (error) {

      }
    },
    saveSettings () {
      const settings = {
        reflectWSSTarget: this.reflectWSSTarget,
        reflectProjectId: this.reflectProjectId,
        reflectScreenId: this.reflectScreenId,
        reflectPasskey: this.reflectPasskey,
        sednaTarget: this.sednaTarget
      }
      localStorage.setItem('settings', JSON.stringify(settings))
    },
    subscribe () {
      this.wsStore.sendMessage({
        action: 'ready',
        screenId: this.reflectScreenId,
        projectId: this.reflectProjectId,
        key: this.reflectPasskey
      })
    },
    connect () {
      this.wsStore.$patch({ url: this.reflectWSSTarget })
      this.wsStore.connect(true, Infinity, true)

      if (this.wsStore.connection) {
      // On Connection Open
        // this.wsStore.connection.onopen = () => {
        // }

        this.wsStore.onOpenPromises.push(async (data: Event) => {
          console.log('Connection open')

          this.subscribe()

          this.connected = true
        })

        this.wsStore.onMessagePromises.push(async (data: MessageEvent) => {
          console.log('WS - Message: === ', data.data)
          const body = JSON.parse(data.data)

          // http://192.168.155.103:17236/services;execute?command=start%20playlist%20-n%20name
          // const newTimeout = setTimeout()

          if (body.commands && Array.isArray(body.commands)) {
            for (let i = 0; i < body.commands.length; i++) {
              const command = body.commands[i]

              // If supported command
              if (commands.includes(command.command)) {
                switch (command.command) {
                  case 'SEDNA_EXECUTE':
                    console.log(command)

                    if (command.delay && parseInt(command.delay)) {
                      const newTimeoutId = setTimeout(() => {
                        console.log(newTimeoutId)
                        // this.messages.push(`Ran timeout id "${newTimeoutId}" - running ${this.sednaUrl + command.url}`)

                        fetch(this.sednaUrl + command.url)

                        const index = this.timeouts.findIndex((timeout) => timeout.id === newTimeoutId)
                        this.timeouts.splice(index, 1)
                      }, parseInt(command.delay))

                      this.timeouts.push({ id: newTimeoutId, ...command })
                      this.messages.push('Sedna Command with ' + command.delay + 'ms delay - ' + command.url)
                    } else {
                      fetch(this.sednaUrl + command.url)
                      this.messages.push('Sedna Command - ' + command.url)
                    }

                    break
                  case 'CLEAR_QUEUE':
                    this.timeouts.forEach(timeout => clearTimeout(timeout.id))
                    this.timeouts = []
                    break
                  default:
                    break
                }
              } else this.messages.push(' === Was given an unsupported command - ' + JSON.stringify(command) + ' === ')
            }
          } else this.messages.push(' === Not a Sedna-based command ===\n' + JSON.stringify(body) + '\n === ')

          // if (body.prize) {
          //   let playlist = ''

          //   if (body.prize === 'lose') playlist = 'PR-LSE'
          //   else if (body.prize === 'win') playlist = 'PR-WIN'
          //   else if (body.prize === 'jackpot') playlist = 'PR-JP'
          //   else return

          //   this.executeSendaPlaylist(this.buildSednaURL({
          //   // host: '192.168.155.103',
          //     host: 'localhost',
          //     loop: false,
          //     overlay: true,
          //     fadeIn: 1,
          //     fadeOut: 1,
          //     name: playlist,
          //     type: SednaAssetType.Playlist,
          //     command: SednaCommand.Start
          //   }))
          // }
        })

        // this.wsStore.connection.onmessage = (data) => {
        //   const body = JSON.parse(data.data)
        // }

        this.wsStore.onClosePromises.push(async (data: Event) => {
          console.log('Connection closed')

          this.connected = false
        })
      }
    },
    buildSednaURL (options: SednaTriggerOptions): URL {
      let url = 'http://' + options.host + ':17236/services;execute?command=start%20' + options.type + '%20'

      if (options.name) url += '-n "' + options.name + '" '

      if (options.overlay) url += '-overlay '

      if (options.loop) url += '-loop '

      if (options.fadeIn) url += '-fadein ' + options.fadeIn + ' '
      if (options.fadeOut) url += '-fadeout ' + options.fadeOut + ' '

      return new URL(url)
    },
    executeSendaPlaylist (url: URL) {
      const xhttp = new XMLHttpRequest()
      xhttp.onload = function () {
        console.log('Sedna Result for', url, ' ---- ', this.responseText)
      }
      xhttp.open('GET', url, true)
      xhttp.send()
    }
  }
})

// switch (this.params.stage) {
//   case '1':
//     this.wsStore.connection.onmessage = (data) => {
//       const body = JSON.parse(data.data)
//       if (body.video === 'entrance') {
//         console.log('Going to Entrance playlist')
//         this.executeSendaPlaylist(body.video, 'localhost', false)
//       }
//     }
//     break

//   case '2':
//     this.wsStore.connection.onmessage = (data) => {
//       const body = JSON.parse(data.data)

//       if (body.video === 'bottle' || body.video === 'fragrance' || body.video === 'campaign') {
//         console.log('Showing room overlay')
//         this.executeSendaPlaylist(body.video, 'localhost', true)
//       }
//     }
//     break

//   default:
//     break
// }
